import React from 'react';
import PropTypes from 'prop-types';

const staticText = (props) => {
  return <p>{props.value}</p>;
};

export default staticText;
